<template>
  <div class="bbh-readonly-quill">
    <quill-editor
      :options="op"
      :disabled="true"
      :value="value"
    />
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'
export default {
  name: 'ReadonlyQuill',
  components: { quillEditor },
  props: {
    value: {
      type: String,
      required: true
    }
  },
  data: () => ({
    op: {
      modules: {
        toolbar: false
      }
    }
  })
}
</script>

<style lang="scss">
.bbh-readonly-quill {
    .ql-container.ql-snow{ border: none !important;}
}
</style>
